import {appdata} from "../../logic_tmp/appdata/AppData";
import React from "react";
import {getImpl} from "../../backend/LgSetup";



export function EventData() {
    let product = appdata.product
    let miniLogo = "🎼"

    if (appdata.product.type === "PDF" || appdata.product.type === "BOOK")
        miniLogo = "📖"
    return (
        <h2 className="offer-pay__title">
            {miniLogo}{getImpl(product,["name"])}{(appdata.product.date !== "ANY")?
                <div>📆{appdata.product.dateStr}  {appdata.product.timeStr}</div>:<div/>
            }
            {(getImpl(product.place,["name"]) !== "ANY")?<div>
            👉{appdata.product.place["address"]}</div>:<div></div>}
        </h2>

    )
}
